import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { InputText } from "primereact/inputtext"
import { updateState } from "../../../utils/utils"

const SubstanceUseRow = (props) => {
  const {
    days,
    daysSet,
    legend,
    routeOptions,
    route,
    routeSet,
    showDays,
    disabled,
    summaryDisabled,
    numberError,
    numberErrorType,
    removeError,
    showRoute,
    showConfirmation,
    confirmation,
    setConfirmation,
    confirmationOptions,
    removeErrors,
    extraValues,
    confirmationDisabled,
    showText,
    textError,
    text,
    setText,
    entity,
    setEntity,
    defaultZero,
    required
  } = props
  return (
    <div className={gpraStyles.substanceRowContainer}>
      {legend && (
        <div className={gpraStyles.substanceUseRowLabel}>
          <label className={gpraStyles.ml1}>{legend}{required && <span className={gpraStyles.required}> *</span>}</label>
        </div>
      )}
      {showConfirmation && (
        <Dropdown
          value={confirmation}
          onChange={(e) => {
            updateState(
              setConfirmation,
              e.value,
              null,
              null,
              entity,
              setEntity,
              extraValues
            )
            removeError(numberErrorType)
            if (!e.value && daysSet) {
              updateState(
                setConfirmation,
                e.value,
                null,
                null,
                entity,
                setEntity,
                [...extraValues, ...[{ key: daysSet, value: 0 }]]
              )
            }
            if (removeErrors) {
              removeErrors.forEach((error) => {
                removeError(error)
              })
            }
          }}
          options={confirmationOptions}
          optionLabel="label"
          optionValue="value"
          disabled={summaryDisabled || confirmationDisabled}
          showClear={confirmation !== undefined && confirmation !== ""}
          className={
            numberError
              ? gpraStyles.substanceUseRowConfirmationError
              : gpraStyles.substanceUseRowConfirmation
          }
        />
      )}
      {showDays && (
        <div
          className={
            showConfirmation && numberError
              ? gpraStyles.invalid
              : gpraStyles.input2
          }
        >
          <InputNumber
            value={!days && defaultZero ? 0 : days}
            onValueChange={(e) => {
              if (!e.value || e.value === 0) {
                updateState(daysSet, e.value, null, null, entity, setEntity, [
                  { key: routeSet, value: 0 },
                  { key: setText, value: "" },
                ])
              } else {
                updateState(
                  daysSet,
                  e.value,
                  null,
                  null,
                  entity,
                  setEntity,
                  null
                )
              }
              if (removeError) {
                removeError(numberErrorType)
                removeError(setText)
              }
            }}
            showButtons
            min={0}
            suffix=" Days"
            disabled={
              (showConfirmation && !confirmation) || disabled || summaryDisabled
            }
          />
        </div>
      )}
      {showText && (
        <InputText
          className={
            textError ? gpraStyles.inputText3Error : gpraStyles.inputText3
          }
          disabled={disabled}
          value={text}
          onChange={(e) => {
            updateState(
              setText,
              e.target.value,
              null,
              null,
              entity,
              setEntity,
              null
            )
            removeError(setText)
          }}
          placeholder="Other (Specify)"
        />
      )}
      {showRoute && (
        <Dropdown
          className={numberError ? gpraStyles.input4Error : gpraStyles.input4}
          value={route}
          onChange={(e) => {
            updateState(routeSet, e.value, null, null, entity, setEntity)
            removeError(numberErrorType)
          }}
          options={routeOptions}
          optionLabel="label"
          optionValue="value"
          placeholder="Route"
          disabled={!days || summaryDisabled}
          showClear={route}
        />
      )}
      {numberError ? (
        <FormError error={numberError} />
      ) : (
        textError && <FormError error={textError} />
      )}
    </div>
  )
}

SubstanceUseRow.defaultProps = {
  showDays: true,
  showRoute: true,
  showConfirmation: false,
  showText: false,
  extraValues: [],
}
export default SubstanceUseRow
